import { connect } from 'react-redux';

import UserSettingsPanel from './';
import * as userActions from '../../actions/userActions';

const mapStateToProps = state => ({
  showLogoutButton: !state.identity.isWebappUser
});

const mapDispatchToProps = dispatch => ({
  logout: () => dispatch(userActions.logout())
});

export default connect(mapStateToProps, mapDispatchToProps)(UserSettingsPanel);